module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/76ccd0256823b4d9ddc795a22dbd49f7.png";